
import { Component, Vue} from 'vue-property-decorator'

@Component({
  template: `
  <span>{{ $store.state.cart.itemsCount }}</span>
  `
})

export default class ShoppingCartMenuButton extends Vue {}
